import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { object, array } from "prop-types";

import Organism2 from "../../organisms/organism-2";
import Organism3 from "../../organisms/organism-3";

import { getSlug } from "../../utils";

import "./eleven-stories-eleven-images.m.css";

const ElevenStoriesElevenImages = ({ collection, sections }) => {
  const collectionItems = collection.items ? collection.items : [];
  const filteredCollectionItems = collectionItems.filter(item => item.type === "collection").slice(0, 4);
  const hasItems = filteredCollectionItems.slice(-1)[0] && filteredCollectionItems.slice(-1)[0].items.length > 0;
  const organism2Set = filteredCollectionItems.slice(0, 3).map((item, index) => {
    const totalItems = item.items.length;
    const childCollection = item.items ? item.items : [];
    const collectionName = item.name;
    const slug = getSlug(item, sections);
    const collectionStories = childCollection.filter(item => item.type === "story").slice(0, 4);
    const collectionOfCollections = childCollection.filter(item => item.type === "collection").slice(0, 3);

    return (
      <Organism2
        collectionStories={collectionStories}
        collectionOfCollections={collectionOfCollections}
        key={index}
        collectionName={collectionName}
        limit={2}
        headerType={14}
        headlineLimit={75}
        collection={item}
        totalItems={totalItems}
        href={slug}
      />
    );
  });
  const organism3Set = <Organism3 collection={filteredCollectionItems.slice(-1)[0]} limit={2} headlineLimit={70} />;

  return (
    <div styleName="wrapper">
      {organism2Set}
      {filteredCollectionItems.length === 4 && hasItems && organism3Set}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(ElevenStoriesElevenImages);

ElevenStoriesElevenImages.propTypes = {
  collection: object,
  sections: array
};
